import { render } from "./UserDashboard.vue?vue&type=template&id=3f5cfee8&scoped=true&ts=true"
import script from "./UserDashboard.vue?vue&type=script&lang=ts"
export * from "./UserDashboard.vue?vue&type=script&lang=ts"

import "./UserDashboard.vue?vue&type=style&index=0&id=3f5cfee8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f5cfee8"]])

export default __exports__